import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { ICatalog } from '@shared/models/icommons.model';
import { PageName } from '@shared/services/page-titles.enum';
import { SharedService } from '@shared/services/shared.service';
import { HttpMethods } from '@cbre/http';
import { BehaviorSubject } from 'rxjs';
import { filter, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class FaqService extends HttpMethods implements OnDestroy {
  private _currentPageId = new BehaviorSubject<number>(null);
  public currentPageId$ = this._currentPageId.asObservable();

  constructor(
    http: HttpClient,
    private sharedService: SharedService
  ) {
    super(http);
  }

  ngOnDestroy(): void {
    this._currentPageId.complete();
  }

  public getFaqs(pageId) {
    const params = new HttpParams({ fromObject: { pageId } });
    return this.httpGet('/help/faqs', params);
  }

  public createFaq(data) {
    return this.httpPost('/help/faqs', data);
  }

  public likeFaq(data) {
    return this.httpPut('/help/faqs', data);
  }

  public setCurrentPageId(page: PageName) {
    this.sharedService
      .findAppCatalogItem(page)
      .pipe(
        take(1),
        filter(catalog => Boolean(catalog))
      )
      .subscribe((catalog: ICatalog) => this._currentPageId.next(catalog.key as number));
  }
}
